import LocationDetailGeneralInformation from './LocationDetailGeneralInformation';
import LocationDetailReturnShipping from './LocationDetailReturnShipping';
import LocationDetailUserAssign from './LocationDetailUserAssign';
import { ILocationTabsData } from './types';

export const getTabs = (): ILocationTabsData[] => [
  { component: LocationDetailUserAssign, title: 'Manage Location Users' },
  { component: LocationDetailGeneralInformation, title: 'Location Details' },
  { component: LocationDetailReturnShipping, title: 'Document Return Shipping' },
];
